// import Vue from 'vue'
// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => { console.log(); })
}

const routes = [{
        path: '/',
        redirect: {
            name: "broadcast"
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        component: () =>
            import ('@/components/information/broadcast.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () =>
            import ('@/components/information/project.vue'),
    },
    {
        path: '/report',
        name: 'report',
        component: () =>
            import ('@/components/research/report.vue'),
    },
    {
        path: '/comments',
        name: 'comments',
        component: () =>
            import ('@/components/research/comments.vue'),
    },
    {
        path: '/exposure',
        name: 'exposure',
        component: () =>
            import ('@/components/complaints/exposure.vue'),
    },
    {
        path: '/complainList',
        name: 'complainList',
        component: () =>
            import ('@/components/complaints/complainList.vue'),
    },
    {
        path: '/rating',
        name: 'rating',
        component: () =>
            import ('@/components/complaints/rating.vue'),
    },
    {
        path: '/appstore1',
        name: 'appstore1',
        component: () =>
            import ('@/components/data/appstore1.vue'),
    },
    {
        path: '/appstore2',
        name: 'appstore2',
        component: () =>
            import ('@/components/data/appstore2.vue'),
    },
    {
        path: '/appstore3',
        name: 'appstore3',
        component: () =>
            import ('@/components/data/appstore3.vue'),
    },
    {
        path: '/appstore4',
        name: 'appstore4',
        component: () =>
            import ('@/components/data/appstore4.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router